import React from 'react';
import PropTypes from 'prop-types';
import { EmphasisTag } from '@welldev-group/react-comp-lib';
import Tooltip from '@welldev-group/rcl-tooltip';

const ApprovalRequiredLabel = ({ className, reason }) => {
  const approvalRequiredLabelTag = (
    <EmphasisTag
      text={I18n.t('components.ibe.search_result.approval_required')}
      type="warning"
      size="tiny"
      className={className}
    />
  );

  const content = reason ? (
    <Tooltip content={reason} position="top-left" type="dark">
      {approvalRequiredLabelTag}
    </Tooltip>
  ) : (
    approvalRequiredLabelTag
  );

  return content;
};

ApprovalRequiredLabel.defaultProps = {
  className: null,
  reason: null,
};

ApprovalRequiredLabel.propTypes = {
  className: PropTypes.string,
  reason: PropTypes.string,
};

export default ApprovalRequiredLabel;
